export default "__VITE_ASSET__BqktKRmy__"